'use strict';

var Joi = require('joi');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var GadgetOtpRedeemed = Joi__default["default"].object().keys({
  success: Joi__default["default"].boolean().required().description('Describes whether the otp redemption attempt failed or succeeded'),
  verify_flow_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).required().description("The id that links otp events to an individual & unique verification flow (OTP Request).\n            The verify flow id is a uuid created when the initial otp request associated to an event was made.")
}).description('This event is fired when an end user submits a one time code, and can either be successful or fail.').meta({
  name: 'GadgetOtpRedeemed',
  filename: 'gadget:otp_redeemed.model'
});
var GadgetOtpRedeemed$1 = GadgetOtpRedeemed;

module.exports = GadgetOtpRedeemed$1;
//# sourceMappingURL=otp_redeemed.model.js.map
